import React from 'react';
import styled, { css } from 'styled-components';
import { ApButtonIcon, ApButtonMain, colors } from '@alixpartners/ui-components';
import noDataAvailableForFiltersImage from 'assets/images/noDataAvailableForFilters.png';
import {
	WAVE_PANELS_MARGIN,
	INITIATIVE_HEIGHT,
	INITIATIVE_MARGIN
} from '../constants'

const LEFT_CONTAINER_WIDTH = 542;

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	overflow: hidden;
	max-height: calc(100vh - 96px);
`;

export const Left = styled.div`
	width: ${LEFT_CONTAINER_WIDTH}px;
	min-width: ${LEFT_CONTAINER_WIDTH}px;
	display: flex;
	flex-direction: column;
`;

export const Right = styled.div`
	width: 100%;
	display: flex;
	overflow: auto;
`;

export const ContentHeader = styled.div`
	position: relative;
	height: 56px;
	min-height: 56px;
	border: 1px solid ${colors.grey2};
`;

export const SearchWrapper = styled.div`
	position: absolute;
	width: ${LEFT_CONTAINER_WIDTH}px;
	min-width: ${LEFT_CONTAINER_WIDTH}px;
	padding: 5px 32px;
	top: 0;
`;

export const SubHeader = styled.div`
	height: 32px;
	min-height: 32px;
	display: flex;
	align-items: center;
	padding-left: 40px;
	padding-right: 32px;
	border-bottom: 1px solid ${colors.grey2};
	border-right: 1px solid ${colors.grey2};
`;

export const HeaderColumn = styled.div`
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
	width: 90px;
	text-align: right;
	flex: 1;
`;

export const LongHeaderColumn = styled(HeaderColumn)`
	flex: 3;
	text-align: left;
`;

export const WavesList = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 32px 0 24px;
	border-right: 1px solid ${colors.grey2};
	overflow-y: overlay;
	height: 100%;
`;

export const CollapsibleContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: ${WAVE_PANELS_MARGIN}px;
`;

export const CollapsibleHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 32px;
	position: relative;
	font-weight: 500;
	font-size: 16px;
	color: ${colors.grey8};
	${({ isFaded }) =>
		isFaded &&
			css`
				opacity: 0.2
			`};
`;

export const CollapsibleHeaderTitle = styled.div`
	text-indent: 24px;
	flex: 3;
	white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	line-height: 24px;
`;

export const CollapsibleHeaderValue = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex: 1;
`;

export const CollapsibleButton = styled(ApButtonIcon)`
	transition: transform 0.5s;
	position: absolute;
	left: -12px;
	top: 0;
	${({ isExpanded }) =>
		isExpanded &&
		css`
			svg {
				transform: rotate(180deg);
			}
		`};
`;

export const CollapsibleContent = styled.div`
	display: flex;
	flex-direction: column;
`;

export const HeaderRow = styled.div`
	display: flex;
`;

export const HeaderBlock = styled.div`
	display: flex;
	position: relative;
	height: 32px;
`;

export const InitiativeRow = styled.div`
	display: flex;
	justify-content: space-between;
	height: ${INITIATIVE_HEIGHT}px;
	margin-bottom: ${INITIATIVE_MARGIN}px;
	font-weight: 400;
	font-size: 13px;
	color: ${colors.grey7};
	${({ isFaded }) =>
		isFaded &&
		css`
				opacity: 0.2
			`};
`;

export const NoDataMessageWrapper = styled.div`
	background-image: url(${noDataAvailableForFiltersImage});
	background-repeat: no-repeat;
	background-position: center 0;
	height: 650px;
	padding: 0 8px;
	display: flex;
	flex-direction: column;
	position: absolute;
	top: 20%;
	right: 0;
	left: 0;
	bottom: 0;
	background-size: 460px;
`;

export const NoDataMessageTitle = styled.div`
	margin-top: 375px;
	color: ${colors.grey8};
	font-size: 33px;
	font-style: normal;
	font-weight: 500;
	line-height: 31px;
	letter-spacing: 0.3px;
	text-align: center;
`;

export const NoDataMessageText = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: center;
	height: 64px;
	margin: 36px auto 0;
	width: 310px;
`;

export const NoDataMessage = ({ onCreate, onReset, isWaves, isReset }) => {
	return (
		<NoDataMessageWrapper isWaves={isWaves} isReset={isReset}>
			<NoDataMessageTitle>No data available for this combination of filters</NoDataMessageTitle>
			<NoDataMessageText>
				<ApButtonMain iconName="baseline_undo" onClick={onReset}>
					Reset filters
				</ApButtonMain>
			</NoDataMessageText>
		</NoDataMessageWrapper>
	);
};
